import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/98TDyinpFrqs6MZWeZaun2/LOGO2.png';
export function Header() {
  const scrollToForm = () => {
    document.getElementById('lead-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className="sticky top-0 z-50 bg-brand-dark/80 backdrop-blur-lg border-b border-brand-border/50" data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="flex items-center justify-between h-16 lg:h-20" data-id="element-111">
          <img src={LOGO_URL} alt="Lima Dental Group" className="h-8 lg:h-10 w-auto" data-id="element-112" />
          <button onClick={scrollToForm} className="border border-white/30 hover:bg-white hover:text-brand-dark text-white text-sm font-medium py-2.5 px-6 rounded-full transition-all" data-id="element-113">
            Join the VIP Plan
          </button>
        </div>
      </div>
    </header>;
}